'use strict';

module.exports = {
  appVersion: '7.9.6',

  logout: function (opt) {
    var url;
    if (opt.type === 1) {
      url = 'dianping://me';
    }else if (opt.type === 2) {
      url = 'dianping://home';
    }
    if (url) {
      opt.success = function () {
        this.openScheme({
          url: url
        });
      };      
    }
    this._send('logout', opt);
  },
  login: function (opt) {
    var self = this;
    function getUser(callback) {
      self.getUserInfo({
        success: callback
      });
    }
    // 先强制退出登录
    this.logout({
      type: 0,
      success: function() {
        // 注册事件
        var appearEvent = 'appear';
        // FIXME: loginSuccess 然并卵: 取消登录、已登录情况下不会发此通知，正常登录回调方法处理结果比appear慢！
        // var loginEvent = 'loginSuccess';
        var appearHandler = function () {
          getUser(function (user) {
            if (user && user.token) {
              console.log('login success');
              opt.success && opt.success(user);
            }else{
              console.log('login fail');
              opt.fail && opt.fail(user);
            }
          });
          self.unsubscribe({
            action: appearEvent,
            handle: appearHandler
          });
        };

        self.subscribe({
          action: appearEvent,
          handle: appearHandler
        });

        // 打开登录页
        self.openScheme({
          url: 'dianping://login'
        });
      }
    });
  }
};